// import cryptokit from './cryptokit/index'
// import cofco from './cofco/index'

import cfcaActions from './action/index'

window.cfca = {
  // 底层api
  // cryptokit,
  // cofco,
  // 封装 动作
  action: cfcaActions
}


// WEBPACK FOOTER //
// ./apps/cfca/index.js